import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import find from 'lodash/find'
import { statusColor } from '../../helpers/color'
import { FONTS } from '../../../../constants'

export const InfoData = (props) => {
  const { timesheets, timesheetProject } = props
  const users = timesheets.users
  const user = find(users, { _id: timesheetProject.user_id })
  return (
    <Row>
      <CircleCol>
        <Detail>{ <Status color={ statusColor(timesheetProject.status) } /> }</Detail>
      </CircleCol>
      <FirstCol>
        <Detail>{ user.emp_code }</Detail>
      </FirstCol>
      <NameCol>
        <Detail>{ `${user.first_name} ${user.last_name} (${user.nick_name})` }</Detail>
      </NameCol>
    </Row>
  )
}


InfoData.propTypes = {
  timesheetProject: PropTypes.object,
  timesheets: PropTypes.object,
}
InfoData.defaultProps = {
  timesheetProject: {},
  timesheets: {},
}
const Circle = styled.div`
  font-size: 15px;
  color: #FFFFFF;
  text-align: center;
  line-height: 15px;
  height: 15px;
  width: 15px;
  background-color: #D44B49;
  border-radius: 50%;
`
const CircleCol = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 10px;
  margin-right: 10px;
`
const Status = styled(Circle)`
  background-color: ${props => props.color};
  height: 10px;
  width: 10px;
  margin-top: 3px;
`
const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 200px;
  margin-left: 1% !important;
  margin-right: 1% !important;
`
const FirstCol = styled.div`
  width: 20%;
  display: flex;
  flex-direction: column;
`
const Title = styled.p`
  margin-bottom: 0px;
`
const Detail = styled(Title)`
  font-family: ${FONTS.GOTHAM} !important;
  font-size: ${FONTS.SMALL_SIZE};
`
const NameCol = styled.div`
  width: 70%;
  display: flex;
  flex-direction: column;
  margin-right: 10px;
  margin-left: 10px;
`



// WEBPACK FOOTER //
// ./src/components/timesheet/tab-content/timesheet-by-project/info-col.js